export default __webpack_public_path__ + "static/media/img-0596-poland-premium-face.0dfc7dfe.png";